import { getNumber, lazyWithRetry, throw404Error } from '@tyro/core';
import { CalendarSchedulePlayIcon } from '@tyro/icons';
import { type NavObjectFunction, NavObjectType } from '@tyro/router/types';

const TyroTuitionPage = lazyWithRetry(() => import('./pages/index'));
const Course = lazyWithRetry(() => import('./pages/course'));
import { getCmsRequest } from '@tyro/api';
import { UnViewedTuitionCountLabel } from './components/un-viewed-counter';
import { tyroTuitionCoursesPathName } from './utils/api-config';

export const getRoutes: NavObjectFunction = (t) => [
  {
    type: NavObjectType.Category,
    title: t('navigation:general.title'),
    hasAccess: ({ permissions }) =>
      permissions.hasPermission('ps:1:general_admin:tyro_tuition'),
    children: [
      {
        type: NavObjectType.RootLink,
        info: <UnViewedTuitionCountLabel />,
        path: '/tyro-tuition',
        icon: <CalendarSchedulePlayIcon />,
        title: t('navigation:general.tyroTuition.title'),
        children: [
          {
            type: NavObjectType.NonMenuLink,
            index: true,
            element: <TyroTuitionPage />,
          },
          {
            type: NavObjectType.NonMenuLink,
            path: 'course/:id',
            element: <Course />,
            loader: ({ params }) => {
              const id = getNumber(params.id);

              if (!id) {
                throw404Error();
              }

              return getCmsRequest(tyroTuitionCoursesPathName);
            },
          },
        ],
      },
    ],
  },
];
